document.addEventListener('DOMContentLoaded', function () {

    // ########## Main Navigation Functionality ##########

    // Track hover/focus state explicitly (more reliable than probing :hover)
    document.querySelectorAll('header .main-navigation li[data-nav-tgt]').forEach(function (li) {
        li.addEventListener('pointerenter', function () { li.classList.add('is-hovered'); });
        li.addEventListener('pointerleave', function () { li.classList.remove('is-hovered'); });
        var anchor = li.querySelector('a');
        if (anchor) {
            anchor.addEventListener('focus', function () { li.classList.add('is-hovered'); });
            anchor.addEventListener('blur', function () { li.classList.remove('is-hovered'); });
        }
    });
    document.querySelectorAll('.main-navigation-dropdown[data-nav-id]').forEach(function (drop) {
        drop.addEventListener('pointerenter', function () { drop.classList.add('is-hovered'); });
        drop.addEventListener('pointerleave', function () { drop.classList.remove('is-hovered'); });
    });
    // Track hover/focus for sub-navigation triggers and dropdowns
    document.querySelectorAll('header .main-navigation li[data-subnav-tgt]').forEach(function (li) {
        li.addEventListener('pointerenter', function () { li.classList.add('is-hovered'); });
        li.addEventListener('pointerleave', function () { li.classList.remove('is-hovered'); });
        var anchor = li.querySelector('a');
        if (anchor) {
            anchor.addEventListener('focus', function () { li.classList.add('is-hovered'); });
            anchor.addEventListener('blur', function () { li.classList.remove('is-hovered'); });
        }
    });
    document.querySelectorAll('.sub-navigation-item-dropdown[data-subnav-id]').forEach(function (drop) {
        drop.addEventListener('pointerenter', function () { drop.classList.add('is-hovered'); });
        drop.addEventListener('pointerleave', function () { drop.classList.remove('is-hovered'); });
    });

    // Hover over the main menu items
    document.querySelectorAll('.main-nav-items li').forEach(function (li) {
        li.addEventListener('mouseenter', function () {

            var navID = li.dataset.navTgt;

            if (navID !== undefined) {
                document.querySelectorAll('[data-nav-id="' + navID + '"]').forEach(function (dropEl) {
                    MainNavigationActivateDropdown(dropEl);
                });
            }
        });
        li.addEventListener('mouseleave', function () {
            var navID = li.dataset.navTgt;
            if (navID !== undefined) {
                document.querySelectorAll('[data-nav-id="' + navID + '"]').forEach(function (dropEl) {
                    MainNavigationActivateDropdown(dropEl);
                });
            }
        });
    });

    // Mouse Out for the dropdown
    document.querySelectorAll('.main-navigation-dropdown').forEach(function (el) {
        el.addEventListener('mouseout', function () {
            MainNavigationActivateDropdown(el);
        });
    });

    // ########## Sub Navigation Functionality ##########

    var menuOpen = document.getElementById('menu-open');
    if (menuOpen) {
        menuOpen.addEventListener('click', function () {
            // just in case the tooltip is showing, hide it
            document.querySelectorAll('.persona-form-link').forEach(function (p) {
                p.classList.remove('tooltip-preview');
            });

            var topNavWrapper = menuOpen.parentElement;
            if (topNavWrapper) {
                topNavWrapper.classList.toggle('active');
                // Toggle the siblings with class .main-navigation-mid
                var parent = topNavWrapper.parentElement;
                if (parent) {
                    parent.querySelectorAll('.main-navigation-mid').forEach(function (s) {
                        s.classList.toggle('active');
                    });
                }
            }
        });
    }

    // Set the padding for each of the individual items in the sub nav
    document.querySelectorAll('.sub-nav-items li').forEach(function (li) {
        var hotelNavID = li.dataset.subnavTgt;
        if (hotelNavID !== undefined) {
            // Use offsetLeft as a replacement for jQuery.position().left
            var positionLeft = li.offsetLeft || 0;
            var targetUl = document.querySelector('.sub-navigation-item-dropdown[data-subnav-id="' + hotelNavID + '"] ul');
            if (targetUl) {
                targetUl.style.marginLeft = positionLeft + 'px';
            }
        }
    });

    // Hover over the sub menu items
    document.querySelectorAll('.sub-nav-items li').forEach(function (li) {
        li.addEventListener('mouseenter', function () {
            var navID = li.dataset.subnavTgt;
            if (navID !== undefined) {
                document.querySelectorAll('[data-subnav-id="' + navID + '"]').forEach(function (dropEl) {
                    SubNavigationActivateDropdown(dropEl);
                });
            }
        });
        li.addEventListener('mouseleave', function () {
            var navID = li.dataset.subnavTgt;
            if (navID !== undefined) {
                document.querySelectorAll('[data-subnav-id="' + navID + '"]').forEach(function (dropEl) {
                    SubNavigationActivateDropdown(dropEl);
                });
            }
        });
    });

    // Mouse Out for the dropdown
    document.querySelectorAll('.sub-navigation-item-dropdown').forEach(function (el) {
        el.addEventListener('mouseout', function () {
            SubNavigationActivateDropdown(el);
        });
    });

});

// ########## Main Navigation Functions ##########

function MainNavigationActivateDropdown(dropElement) {

    if (!dropElement) return;
    var navId = dropElement.dataset.navId;
    if (navId === undefined) return;

    var triggerElements = Array.from(document.querySelectorAll('header .main-navigation li[data-nav-tgt="' + navId + '"]'));
    var dropElements = Array.from(document.querySelectorAll('.main-navigation-dropdown[data-nav-id="' + navId + '"]'));

    // Check if any trigger element is hovered (or tracked via is-hovered)
    var triggerHovered = triggerElements.some(function (el) { return el.classList.contains('is-hovered') || el.matches(':hover'); });
    // Check if any dropdown element is hovered (or tracked)
    var dropHovered = dropElements.some(function (el) { return el.classList.contains('is-hovered') || el.matches(':hover'); });

    if (triggerHovered || dropHovered) {
        if (dropElement.classList.contains('active')) {
            triggerElements.forEach(function (el) { el.classList.add('active'); });
        } else {
            dropElement.classList.add('active');
            triggerElements.forEach(function (el) { el.classList.add('active'); });
        }
    } else {
        if (dropElement.classList.contains('active')) {
            dropElement.classList.remove('active');
            triggerElements.forEach(function (el) { el.classList.remove('active'); });
        }
    }
}

// ########## Sub Navigation Functions ##########

function SubNavigationActivateDropdown(dropElement) {
    if (!dropElement) return;
    var subnavId = dropElement.dataset.subnavId;
    if (subnavId === undefined) return;

    var triggerElements = Array.from(document.querySelectorAll('header .main-navigation li[data-subnav-tgt="' + subnavId + '"]'));
    var dropElements = Array.from(document.querySelectorAll('.sub-navigation-item-dropdown[data-subnav-id="' + subnavId + '"]'));

    // Check if any trigger element is hovered (or tracked)
    var triggerHovered = triggerElements.some(function (el) { return el.classList.contains('is-hovered') || el.matches(':hover'); });
    // Check if any dropdown element is hovered (or tracked)
    var dropHovered = dropElements.some(function (el) { return el.classList.contains('is-hovered') || el.matches(':hover'); });

    if (triggerHovered || dropHovered) {
        if (dropElement.classList.contains('active')) {
            triggerElements.forEach(function (el) { el.classList.add('active'); });
        } else {
            dropElement.classList.add('active');
            triggerElements.forEach(function (el) { el.classList.add('active'); });
        }
    } else {
        if (dropElement.classList.contains('active')) {
            dropElement.classList.remove('active');
            triggerElements.forEach(function (el) { el.classList.remove('active'); });
        }
    }
}


